import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 bg-black/95 backdrop-blur-sm border-b border-slate-800 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src="/logo-novopay.png"
              alt="NOVOPAY Logo" 
              className="h-10 w-auto"
              onError={(e) => {
                e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjYwIiB2aWV3Qm94PSIwIDAgMjAwIDYwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8dGV4dCB4PSIxMCIgeT0iNDAiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIyNCIgZm9udC13ZWlnaHQ9ImJvbGQiIGZpbGw9IiNFQUIzMDgiPk5PVk9QQVk8L3RleHQ+Cjwvc3ZnPgo=';
              }}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="#introduccion" className="text-slate-300 hover:text-white transition-colors duration-200">
              Nosotros
            </a>
            <a href="#soluciones" className="text-slate-300 hover:text-white transition-colors duration-200">
              Soluciones
            </a>
            <a href="#tecnologia" className="text-slate-300 hover:text-white transition-colors duration-200">
              Tecnología
            </a>
            <a href="#contacto" className="text-slate-300 hover:text-white transition-colors duration-200">
              Contacto
            </a>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="https://app.novopay.mx"
              className="text-slate-300 hover:text-white transition-colors duration-200"
              data-testid="login-link-desktop"
            >
              Iniciar Sesión
            </a>
            <Button
              asChild
              className="bg-yellow-500 hover:bg-yellow-600 text-black px-6 py-2 rounded-lg font-semibold transition-all duration-200"
            >
              <Link to="/abre-cuenta" data-testid="signup-link-desktop">
                Abre tu Cuenta
              </Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-slate-300 hover:text-white"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-black/95 backdrop-blur-sm">
              <a href="#introduccion" className="text-slate-300 hover:text-white block px-3 py-2 transition-colors duration-200">
                Nosotros
              </a>
              <a href="#soluciones" className="text-slate-300 hover:text-white block px-3 py-2 transition-colors duration-200">
                Soluciones
              </a>
              <a href="#tecnologia" className="text-slate-300 hover:text-white block px-3 py-2 transition-colors duration-200">
                Tecnología
              </a>
              <a href="#contacto" className="text-slate-300 hover:text-white block px-3 py-2 transition-colors duration-200">
                Contacto
              </a>
              <div className="pt-4 pb-2 space-y-2">
                <a
                  href="https://app.novopay.mx"
                  className="text-slate-300 hover:text-white block px-3 py-2 w-full text-left transition-colors duration-200"
                  data-testid="login-link-mobile"
                >
                  Iniciar Sesión
                </a>
                <Button
                  asChild
                  className="bg-yellow-500 hover:bg-yellow-600 text-black w-full mx-3 rounded-lg font-semibold transition-all duration-200"
                >
                  <Link to="/abre-cuenta" data-testid="signup-link-mobile">
                    Abre tu Cuenta
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
